/* eslint no-var: "off" */

// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item

export enum ButtonType {
  CHECKOUT = 'Checkout',
  COUPON_LINK = 'Coupon Link',

  // Page Heroes
  HOMEPAGE_HERO = 'Homepage Hero',
  VIRTUAL_OFFICE_PHONE_PAGE_HERO = 'WhatsApp Business Number Page Hero',
  VIRTUAL_OFFICE_FORWARD_PAGE_HERO = 'Virtual Office Forward Page Hero',
  VIRTUAL_OFFICE_LONDON_PAGE_HERO = 'Virtual Office London Page Hero',
  ACCOUNTING_SERVICE_PAGE_HERO = 'Accounting Service Page Hero',
  BUSINESS_BANKING_PAGE_HERO = 'Business Banking Page Hero',
  MOBILE_PAGE_HERO = 'Mobile Page Hero',
  AU_HOMEPAGE_HERO = 'AU Homepage Hero',
  AU_ENTERPRISE_PAGE_HERO = 'AU Enterprise Page Hero',
  VIRTUAL_OFFICE_SYDNEY_PAGE_HERO = 'Virtual Office Sydney Page Hero',
  VIRTUAL_OFFICE_SYDNEY_PRICING = 'Virtual Office Sydney Pricing',
  VIRTUAL_OFFICE_SYDNEY_CTA = 'Virtual Office Sydney CTA',

  // Page CTAs (non-hero sections)
  HOMEPAGE_TESTIMONIALS_CTA = 'Homepage Testimonials CTA',
  AU_HOMEPAGE_TESTIMONIALS_CTA = 'AU Homepage Testimonials CTA',
  HOMEPAGE_NO_FEES_CTA = 'Homepage No Fees CTA',
  AU_HOMEPAGE_NO_FEES_CTA = 'AU Homepage No Fees CTA',
  VIRTUAL_OFFICE_FORWARD_DEMO_CTA = 'Virtual Office Forward Demo CTA',
  VIRTUAL_OFFICE_LONDON_PORTAL_DEMO_CTA = 'Virtual Office London Portal Demo CTA',
  VIRTUAL_OFFICE_LONDON_KEY_BENEFITS_CTA = 'Virtual Office London Key Benefits CTA',
  VIRTUAL_OFFICE_LONDON_DIRECTORS_ADDRESS_CTA = 'Virtual Office London Directors Address CTA',
  VIRTUAL_OFFICE_LONDON_MAIL_HANDLING_CTA = 'Virtual Office London Mail Handling CTA',

  // Card Components
  APP_PROMO_CARD = 'App Promo Card',
  FEATURES_CARD = 'Features Card',
  LONDON_VO_PLUS_HERO_CARD = 'London VO Plus Hero Card',
  MAIL_FORWARDING_DETAILS_CARD = 'Mail Forwarding Details Card',
  MAIL_FORWARDING_OPTIONS_CARD = 'Mail Forwarding Options Card',
  VIRTUAL_ADDRESS_PROMO_CARD = 'Virtual Address Promo Card',
  WORK_FROM_ANYWHERE_CARD = 'Work From Anywhere Card',
}

export type GAEventType = 'page_view' | 'event'
export type GAEvent =
  | 'add_to_cart_ga4'
  | 'remove_from_cart_ga4'
  | 'purchase_ga4'
  | 'view_item_ga4'
  | 'add_shipping_info'
  | 'add_payment_info'

export interface GA4Item {
  item_id: string
  item_name: string
  price: string
  currency: string
  affiliation?: string
  coupon?: string
  discount?: number
  index?: number
  item_brand?: string
  item_category?: string
  item_category2?: string
  item_category3?: string
  item_category4?: string
  item_category5?: string
  item_list_id?: string
  item_list_name?: string
  item_variant?: string
  location_id?: string
  quantity?: number
  promotion_id?: string
  promotion_name?: string
}

export interface GA4Purchase {
  currency: string
  transaction_id: string
  value: string
  items: GA4Item[]
  coupon?: string
  affiliation?: string
  tax?: string
  shipping?: string
  // Attribution match keys forwarded to sGTM as event-level params.
  // Meta CAPI userDataList consumes em/fbc/fbp; Stape Conversion Improver
  // consumes em + gclid for Google Ads Enhanced Conversions matching.
  // Lifted to dataLayer root by project/api.ts gtag() so sGTM "Event Data"
  // resolvers see them instead of looking inside ecommerce_ga4.
  em?: string
  gclid?: string
  fbc?: string
  fbp?: string
}

export interface GA4AddToCart {
  currency: string
  transaction_id?: string
  value: string
  items: GA4Item[]
  button_type?: string
}

export interface GA4AddShippingInfo {
  currency: string
  value: string
  items: GA4Item[]
  coupon?: string
}

export interface GA4AddPaymentInfo {
  currency: string
  value: string
  items: GA4Item[]
  coupon?: string
  payment_type?: string
}

export type GAEventData =
  | GA4Purchase
  | GA4AddToCart
  | GA4AddShippingInfo
  | GA4AddPaymentInfo

export type DataLayerPayload = {
  ecommerce_ga4?: GAEventData
  event?: string
  item_id?: string
  item_ids?: string
  [key: string]: any
}

declare global {
  var dataLayer:
    | {
        push: (data: DataLayerPayload) => void
      }
    | undefined
  var CRISP_WEBSITE_ID: string
  var $crisp: any
  var __DEV__: boolean | undefined
}
